import React, { Component } from 'react'
import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material'

import { FormInputLabel } from '@/shared/ui/input'

class DecimalFormatSettings extends Component {
    constructor(props) {
        super(props)
        const settings = this.getSettings()
        this.state = {
            format: settings.format ?? '',
            unit: settings.unit ?? '',
            unitPosition: settings.unit_position ?? 'after',
            decimalPlaces: settings.decimal_places ?? 2,
            ratingMax: settings.rating_max ?? 5,
        }

        this.handleSettingChange = this.handleSettingChange.bind(this)
    }

    getSettings() {
        const defField = this.props.item?.def_field ?? {}

        return {
            ...(defField.settings ?? {}),
            ...defField,
            ...(this.props.item?.settings ?? {}),
        }
    }

    handleSettingChange(stateKey, settingKey, value) {
        this.setState({ [stateKey]: value })
        this.props.onChange(settingKey, value)
    }

    render() {
        const { kedo } = this.props
        const { format, unit, unitPosition, decimalPlaces, ratingMax } =
            this.state

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FormControl fullWidth margin="dense">
                    <FormInputLabel>{kedo.t('Format')}</FormInputLabel>
                    <Select
                        size="small"
                        name="format"
                        value={format}
                        required
                        displayEmpty
                        onChange={(e) =>
                            this.handleSettingChange(
                                'format',
                                'format',
                                e.target.value
                            )
                        }
                    >
                        <MenuItem value="">
                            {kedo.t('Choose an option')}
                        </MenuItem>
                        <MenuItem value="number">{kedo.t('Number')}</MenuItem>
                        <MenuItem value="currency">
                            {kedo.t('Currency')}
                        </MenuItem>
                        <MenuItem value="percentage">
                            {kedo.t('Percentage')}
                        </MenuItem>
                        <MenuItem value="measurement">
                            {kedo.t('Measurement')}
                        </MenuItem>
                        <MenuItem value="rating">{kedo.t('Rating')}</MenuItem>
                    </Select>
                </FormControl>

                {['number', 'percentage', 'measurement'].includes(format) && (
                    <TextField
                        label={kedo.t('Decimal places')}
                        type="number"
                        size="small"
                        value={decimalPlaces}
                        onChange={(e) =>
                            this.handleSettingChange(
                                'decimalPlaces',
                                'decimal_places',
                                Number(e.target.value)
                            )
                        }
                        inputProps={{ min: 0, max: 8 }}
                        fullWidth
                    />
                )}

                {format === 'measurement' && (
                    <>
                        <TextField
                            label={kedo.t('Unit')}
                            size="small"
                            value={unit}
                            onChange={(e) =>
                                this.handleSettingChange(
                                    'unit',
                                    'unit',
                                    e.target.value
                                )
                            }
                            fullWidth
                        />
                        <FormControl fullWidth margin="dense">
                            <FormInputLabel>
                                {kedo.t('Unit position')}
                            </FormInputLabel>
                            <Select
                                size="small"
                                name="unit_position"
                                value={unitPosition}
                                onChange={(e) =>
                                    this.handleSettingChange(
                                        'unitPosition',
                                        'unit_position',
                                        e.target.value
                                    )
                                }
                            >
                                <MenuItem value="before">
                                    {kedo.t('Before')}
                                </MenuItem>
                                <MenuItem value="after">
                                    {kedo.t('After')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </>
                )}

                {format === 'rating' && (
                    <TextField
                        label={kedo.t('Maximum rating')}
                        type="number"
                        size="small"
                        value={ratingMax}
                        onChange={(e) =>
                            this.handleSettingChange(
                                'ratingMax',
                                'rating_max',
                                Number(e.target.value)
                            )
                        }
                        inputProps={{ min: 1, max: 10 }}
                        fullWidth
                    />
                )}
            </Box>
        )
    }
}

export default DecimalFormatSettings
